import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { api } from "../api.js";
import dayjs from "dayjs";
import { getCommonApiParams } from "../../../../utils/redux-helpers.js";
import { API_DATE_FORMAT } from "../../../../app_constants.js";

export const SET_UPDATES_LOADING = "saga/memberVisits/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/memberVisits/SET_FILTERS_DIRTY";
export const SET_MODULE_VIEW = "saga/memberVisits/SET_MODULE_VIEW";
export const SET_LOADING = "saga/memberVisits/SET_LOADING";
export const SET_DATES = "saga/memberVisits/SET_DATES";

export const FETCH_CURRENT_USER_SUCCESS = "saga/memberVisits/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/memberVisits/FETCH_FILTERS_SUCCESS";
export const FETCH_CURRENT_USER = "saga/memberVisits/FETCH_CURRENT_USER";
export const IN_STORE_DATA_SUCCESS = "saga/memberVisits/IN_STORE_DATA_SUCCESS";
export const CROSS_CLUB_RANKING_DATA_SUCCESS = "saga/memberVisits/CROSS_CLUB_RANKING_DATA_SUCCESS";

export const UPDATE_CUSTOM_RANGE = "saga/memberVisits/UPDATE_CUSTOM_RANGE";
export const UPDATE_MODULE_VIEW = "saga/memberVisits/UPDATE_MODULE_VIEW";
export const UPDATE_FILTER = "saga/memberVisits/UPDATE_FILTER";
export const UPDATE_DATES = "saga/memberVisits/UPDATE_DATES";
export const UPDATE_DATA = "saga/memberVisits/UPDATE_DATA";

export const RESET_SELECTED_FILTERS = "saga/memberVisits/RESET_SELECTED_FILTERS";
export const RESET_DATA = "saga/memberVisits/RESET_DATA";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateModuleView: createAction(UPDATE_MODULE_VIEW),
  updateFilter: createAction(UPDATE_FILTER),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_DATA),
  resetData: createAction(RESET_DATA)
};

export default function* watchMemberVisits() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_MODULE_VIEW, updateView);
  yield takeLatest(UPDATE_DATA, updateDataByView);
  yield takeLatest(RESET_DATA, resetData);
}

function* getCurrentUserData(data) {
  try {
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });
    yield put({ type: SET_LOADING, payload: true });
    yield setDates();
    yield requestByView();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateView({ payload }) {
  yield put({ type: SET_MODULE_VIEW, payload: payload });
  yield resetData();
}

function* fetchCrossClubRankingData() {
  try {
    yield put({ type: SET_UPDATES_LOADING, payload: true });

    const params = yield getApiParams();
    const { data } = yield call(api.crossClubRanking.getData, params);

    yield put({
      type: CROSS_CLUB_RANKING_DATA_SUCCESS,
      payload: data
    });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchCrossClubRankingFilters() {
  try {
    const params = yield getCommonApiParams("commonReducer", "commonProps");
    const { data } = yield call(api.crossClubRanking.getFilters, { params });

    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });
  } catch (error) {
    console.error(error);
  }
}

function* fetchInStoreData() {
  try {
    yield put({ type: SET_UPDATES_LOADING, payload: true });

    const params = yield getApiParams();
    const { data } = yield call(api.inStoreVsCrossClub.getData, params);

    yield put({
      type: IN_STORE_DATA_SUCCESS,
      payload: data
    });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchInStoreFilters() {
  try {
    const params = yield getCommonApiParams("commonReducer", "commonProps");
    const { data } = yield call(api.inStoreVsCrossClub.getFilters, { params });

    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* requestByView() {
  const moduleView = yield select((state) => state.memberVisits.selectedFilters.moduleView.id);

  if (moduleView === "inStoreVsCrossClub") {
    yield call(fetchInStoreFilters);
    yield call(fetchInStoreData);
  } else {
    yield call(fetchCrossClubRankingFilters);
    yield call(fetchCrossClubRankingData);
  }
}

export function* updateDataByView() {
  const moduleView = yield select((state) => state.memberVisits.selectedFilters.moduleView.id);

  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  if (moduleView === "inStoreVsCrossClub") {
    yield call(fetchInStoreData);
  } else {
    yield call(fetchCrossClubRankingData);
  }
}

function* setDates() {
  const endDate = yield select((state) => state.memberVisits.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).startOf("month").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* resetData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_LOADING, payload: true });

  yield put({ type: RESET_SELECTED_FILTERS });
  yield setDates();

  try {
    yield requestByView();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getApiParams() {
  let commonParams = yield getCommonApiParams("commonReducer", "commonProps");

  let {
    membership_types,
    requestDates: { startDate, endDate },
    moduleView,
    date,
    period_days
  } = yield select((state) => state.memberVisits.selectedFilters);

  const paramsByView =
    moduleView.id == "inStoreVsCrossClub"
      ? {
          start_date: startDate,
          end_date: endDate,
          membership_type_ids: membership_types.map((elem) => elem.id)
        }
      : { period_days: period_days.id, date };

  return {
    ...commonParams,
    ...paramsByView
  };
}
